module.exports = __webpack_public_path__ + "img/P150T_weapon_10.3daeb7f3.png";